import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {MUTATION_KEYS} from '@/queryClient'
import {httpDeleteMedicalReport} from '@/features/medical-reports/http/medicalReports.http'

export const useDeleteMedicalReport = (medicalReportId: string, options?: Omit<UseMutationOptions, 'mutationFn'>) =>
    useMutation({
        mutationKey: [MUTATION_KEYS.DELETE_MEDICAL_REPORT],
        mutationFn: () => httpDeleteMedicalReport({urlParams: {medicalReportId}}),
        ...options
    })
